import Vue from 'vue';
import Vuex from 'vuex';
// import VuexPersist from 'vuex-persist';
import VuexPersistence from 'vuex-persist';
import localforage from 'localforage';

// --------------------------------
// init store
// --------------------------------
let stores = {};
let storeModules = {};

const modules = require.context('./modules', false, /\.module\.js$/);
const moduleName = (string) => {
	return string.replace('.module.js', '').replace('./', '');
};

modules.keys().forEach((key) => (stores[key] = modules(key)));

for (let store in stores) {
	for (let j in stores[store]) {
		storeModules[moduleName(store)] = stores[store][j];
	}
}

Vue.use(Vuex);

// --------------------------------
// managing errors
// --------------------------------
const state = {
	error: {},
	auth: null
};

const getters = {
	error: (state) => state.error,
	auth: (state) => state.auth
};

const mutations = {
	SET_ERROR(state, error) {
		state.error = error;
	},
	RESET_ERROR(state, resetError) {
		state.error = resetError;
	},

	SET_AUTH(state, user) {
		state.auth = Object.assign({}, state.auth, user);
	}
};

const actions = {
	//Set thes errors in state
	throwError({ commit }, error) {
		commit('SET_ERROR', error);
	},
	//Empty the state error
	resetError({ commit }) {
		const resetError = {};
		commit('RESET_ERROR', resetError);
	},

	setAuthUser({ commit }, profile) {
		commit('SET_AUTH', profile);
	}
};

// const vuexLocalStorage = new VuexPersist({
// 	key: 'vuex',
// 	storage: window.localStorage
// });

// Configure localforage with retry logic
localforage.config({
	driver: [localforage.INDEXEDDB, localforage.WEBKIT_SQL, localforage.LOCALSTORAGE],
	name: 'thegreenshot',
	storeName: 'thegreenshot_store',
	description: 'Vuex Store Persistence for Thegreenshot',
	size: 4980736, // ~5MB
	version: 1.0,
	driverOptions: {
		IndexedDB: {
			retry: true,
			maxRetryDelay: 3000 // Maximum delay between retries in ms
		}
	}
});

// Create wrapper store functions with error handling
const retryOperation = async (error, isSetOperation = false, key = null, value = null) => {
	if (error && error.message && error.message.includes('Connection to Indexed Database server lost')) {
		// Implement exponential backoff
		const delay = 1000; // Start with 1 second
		await new Promise((resolve) => setTimeout(resolve, delay));
		// Try operation once more
		if (isSetOperation) {
			await localforage.setItem(key, value);
			return;
		} else {
			return await localforage.getItem(key);
		}
	}
};
const safeStorage = {
	getItem: async (key) => {
		try {
			return await localforage.getItem(key);
		} catch (error) {
			console.error(`Failed to retrieve ${key} from indexedDB:`, error);
			return await retryOperation(error);
		}
	},

	setItem: async (key, value) => {
		try {
			await localforage.setItem(key, value);
		} catch (error) {
			console.error(`Failed to persist ${key} to indexedDB:`, error);
			const isSetOperation = true;
			await retryOperation(error, isSetOperation, key, value);
		}
	}
};

// implementation of a module that persists the store.
const vuexPersist = new VuexPersistence({
	key: 'vuex',
	storage: safeStorage,
	asyncStorage: true
});

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	modules: {
		...storeModules
	},
	plugins: [vuexPersist.plugin]
});
